import { render } from "./EditCommentsModal.vue?vue&type=template&id=609c3b3e"
import script from "./EditCommentsModal.vue?vue&type=script&lang=js"
export * from "./EditCommentsModal.vue?vue&type=script&lang=js"

import "./EditCommentsModal.vue?vue&type=style&index=0&id=609c3b3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__